<!-- Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS -->

<template>
  <ion-page class="modal">
    <ms-modal
      title="WorkspacesPage.workspaceHiddenModal.title"
      :close-button="{ visible: true }"
      :confirm-button="{
        disabled: false,
        label: 'WorkspacesPage.workspaceHiddenModal.actionConfirm',
        onClick: confirmHidden,
      }"
      :cancel-button="{
        label: 'WorkspacesPage.workspaceHiddenModal.actionCancel',
        disabled: false,
      }"
    >
      <div class="workspace-hidden">
        <ms-rich-text
          class="workspace-hidden__description body-lg"
          :text="{ key: 'WorkspacesPage.workspaceHiddenModal.affectedWorkspaces', data: { workspace: workspaceName } }"
        />
      </div>
      <ms-checkbox
        label-placement="end"
        class="workspace-hidden__checkbox body"
        v-model="skipWorkspaceHiddenWarning"
      >
        <ion-text>
          {{ $msTranslate('WorkspacesPage.workspaceHiddenModal.noReminder') }}
        </ion-text>
      </ms-checkbox>
    </ms-modal>
  </ion-page>
</template>

<script setup lang="ts">
import { WorkspaceName } from '@/parsec';
import { IonPage, IonText, modalController } from '@ionic/vue';
import { MsCheckbox, MsModal, MsModalResult, MsRichText } from 'megashark-lib';
import { ref } from 'vue';

defineProps<{
  workspaceName: WorkspaceName;
}>();

const skipWorkspaceHiddenWarning = ref(false);

async function confirmHidden(): Promise<boolean> {
  return await modalController.dismiss(
    {
      skipWorkspaceHiddenWarning: skipWorkspaceHiddenWarning.value,
    },
    MsModalResult.Confirm,
  );
}
</script>

<style scoped lang="scss">
.workspace-hidden {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &__description {
    color: var(--parsec-color-light-secondary-hard-grey);
  }

  &__checkbox {
    position: absolute;
    z-index: 30;
    bottom: 1.625rem;
    color: var(--parsec-color-light-secondary-soft-text);
    padding: 0.25rem 0.25rem;
    border-radius: var(--parsec-radius-8);
    transition: background-color 0.2s ease-in-out;

    &:hover {
      color: var(--parsec-color-light-secondary-text);
      background-color: var(--parsec-color-light-secondary-premiere);
    }
  }
}
</style>
